const getGiveawayTypeResponse = (response) => {
  return response?.data?.giveawayTypes?.map((item) => {
    return {
      value: item?.key,
      label: item?.label,
    };
  });
};

export default getGiveawayTypeResponse;
